<template>
  <div
    class="game-content"
    @contextmenu="handler($event)">
    <game-header />
    <betting />
  </div>
</template>

<script>
import GameHeader from '../components/terminal/main/GameHeader.vue';
import Betting from '../components/terminal/main/Betting.vue';
import { GatewaySvc } from '../services/gateway.service';
import ticketActions from '../model/ticketActions';
import { GameSvc } from '../services/game.service';
import { EventBus } from '../utilities/event.bus';

export default {
  name: 'Game',
  components: {
    GameHeader,
    Betting,
  },

  methods: {
    handler(e) {
      e.preventDefault();
    },
  },

  beforeCreate() {
    GatewaySvc.getGatewaySvc().sendMessage('Product:UpdateSettings', {
      ticketConfig: {
        useTicketLocalStorage: true,
        doTicketStatusCheck: true,
        pendingTicketLimitTotal: 100,
        pendingTicketLimitByGame: 1,
        pendingTicketCheckInterval: 15000,
        pendingTicketRejectPeriod: 60000,
        sentTicketRejectPeriod: 10000,
        availableTicketActions: ticketActions,
        validateTicket: false,
      },
    });

    GameSvc.getGameSvc().setBalls();
    EventBus.$emit('SendSlaveLoaded');
  },
};
</script>

<style lang="scss">
@import '../assets/style/terminal/game';
@import '../../node_modules/@nsftx/nfont/css/icons.css';

.n-i {
  speak: none;
  font-weight: inherit;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// Terminal.vue?3c2b92b4